import {BaseApi} from "@/http/api/BaseApi";
import Cookies from "js-cookie";
import toast from "react-hot-toast";

interface IReturnResponse {
    total: number,
    last_page: number
    data: [],
}

interface IResponse {
    data: {
        total: number,
        last_page: number,
        data: []
    },
    statusCode: number,
    message: string,
}

// const ErrorHandler = useErrorHandler()
export default class AddToWish extends BaseApi {
    getWish = async (data: any): Promise<IReturnResponse | undefined> => {
        try {
            const response: IResponse = await this.post(`profile/wishes`, data, {
                headers: {
                    "Authorization": `Bearer ${Cookies.get("token")}`
                },
                next: {
                    tags: ["wish"]
                }
            })

            if (response.statusCode == 200 || response.statusCode == 201) {
                const message: string = response?.message
                toast.success(message, {
                    position: "top-center",
                })
                return response.data
            } else {
                throw {message: response};
            }

        } catch (error: any) {
            const errorMessage: string = error?.message?.messages
            toast.error(errorMessage, {
                position: "top-center",
            })
        }
    };

    isWish = async (id: string) => {
        try {
            const response = await this.get(`products/${id}/is-wish`, {
                headers: {
                    "Authorization": `Bearer ${Cookies.get("token")}`
                },
            });
            return response;
        } catch (error: any) {
            const errorMessage: string = error?.message?.messages
            toast.error(errorMessage, {
                position: "top-center",
            })
        }
    };


    removeWish = async ({model_id, model}: {
        model_id: string,
        model: string
    }): Promise<IReturnResponse | undefined> => {
        try {
            const response: IResponse = await this.delete(`profile/wishes?model_id=${model_id}&model=${model}`, {
                headers: {
                    "Authorization": `Bearer ${Cookies.get("token")}`
                },
                next: {
                    tags: ["wish"]
                }
            })

            if (response.statusCode == 200 || response.statusCode == 201) {
                const message: string = response?.message
                toast.success(message, {
                    position: "top-center",
                })
                return response.data
            } else {
                throw {message: response};
            }

        } catch (error: any) {
            const errorMessage: string = error?.message?.messages
            toast.error(errorMessage, {
                position: "top-center",
            })
        }
    };
}